import React from 'react';

import { aiConfigItemMessages } from '@atlaskit/editor-common/ai-messages';
import TextAdjustLengthIcon from '@atlaskit/icon-lab/core/text-adjust-length';
import { fg } from '@atlaskit/platform-feature-flags';

import { MakeShorterIcon } from '../../../../icons/prompt/makeShorter';
import type { ConvoAiFeatureId } from '../../../../utils/request/types';
import { createInsertBelow, createReplace } from '../../actions/create-actions';
import { CONFIG_ITEM_KEYS } from '../../config-item-keys';
import type {
	EditorPluginAIConfigItemWithOptionsFactory,
	EditorPluginAIConfigItemFactory,
} from '../../config-items';

export const makeShorter: EditorPluginAIConfigItemFactory = (options) => {
	const featureId: ConvoAiFeatureId = fg('platform_editor_ai_adf_prompts_in_all_products')
		? 'make_shorter_adf_gpt41mini'
		: 'make_shorter';
	const adfPrompt = fg('platform_editor_ai_adf_prompts_in_all_products');

	return {
		key: CONFIG_ITEM_KEYS.MAKE_SHORTER,
		title: aiConfigItemMessages.makeShorterTitle,
		description: aiConfigItemMessages.makeShorterDescription,
		icon: () => <MakeShorterIcon />,
		showInRefineDropdown: true,
		intentSchemaId: 'shorten_intent_schema.json',
		featureId,
		adfPrompt,
		requiresTextualContent: adfPrompt,
		actions: {
			empty: [
				createInsertBelow({ appearance: 'secondary', factoryOptions: options }),
				createReplace({ appearance: 'primary' }),
			],
			selection: [
				createInsertBelow({ appearance: 'secondary', factoryOptions: options }),
				createReplace({ appearance: 'primary' }),
			],
		},
		getBackendModel: () => {
			return 'assistance-service';
		},
		get nestingConfig() {
			if (options?.isInDocumentStreamingEnabled) {
				return {
					id: 'adjust-length',
					parentTestId: 'adjust-length',
					parentTitle: aiConfigItemMessages.adjustLengthNestingParentTitle,
					shortTitle: aiConfigItemMessages.adjustLengthNestingParentShortTitle,
					icon: () => <TextAdjustLengthIcon label="" spacing="spacious" />,
				};
			}
			return undefined;
		},
	};
};

export const makeShorterWithOptions: EditorPluginAIConfigItemWithOptionsFactory = (options) => ({
	config: makeShorter(options),
	triggers: { empty: { enabled: true, docMinSize: 1 }, selection: { enabled: true } },
});
